import * as React from "react";
import logoImg from "../../images/logo.svg";

const Logo = () => {
  return <img src={logoImg} alt="logo" className="u-mb3" />;
};

export default Logo;
